[
  { "type": "constructor", "inputs": [], "stateMutability": "nonpayable" },
  { "type": "receive", "stateMutability": "payable" },
  {
    "type": "function",
    "name": "DEFAULT_ADMIN_ROLE",
    "inputs": [],
    "outputs": [{ "name": "", "type": "bytes32", "internalType": "bytes32" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "UPGRADE_INTERFACE_VERSION",
    "inputs": [],
    "outputs": [{ "name": "", "type": "string", "internalType": "string" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "_msgPayload",
    "inputs": [],
    "outputs": [{ "name": "", "type": "bytes", "internalType": "bytes" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "_msgReceipt",
    "inputs": [],
    "outputs": [
      { "name": "guid", "type": "bytes32", "internalType": "bytes32" },
      { "name": "nonce", "type": "uint64", "internalType": "uint64" },
      {
        "name": "fee",
        "type": "tuple",
        "internalType": "struct MessagingFee",
        "components": [
          { "name": "nativeFee", "type": "uint256", "internalType": "uint256" },
          { "name": "lzTokenFee", "type": "uint256", "internalType": "uint256" }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "_oftReceipt",
    "inputs": [],
    "outputs": [
      { "name": "amountSentLD", "type": "uint256", "internalType": "uint256" },
      { "name": "amountReceivedLD", "type": "uint256", "internalType": "uint256" }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "_options",
    "inputs": [],
    "outputs": [{ "name": "", "type": "bytes", "internalType": "bytes" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "chainId2Eid",
    "inputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "outputs": [{ "name": "", "type": "uint32", "internalType": "uint32" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "chainedEventId",
    "inputs": [],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "claimReward",
    "inputs": [
      { "name": "distributionId", "type": "uint32", "internalType": "uint32" },
      { "name": "cumulativeAmount", "type": "uint256", "internalType": "uint256" },
      { "name": "merkleProof", "type": "bytes32[]", "internalType": "bytes32[]" }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "defaultOftGas",
    "inputs": [],
    "outputs": [{ "name": "", "type": "uint128", "internalType": "uint128" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "eid2ChainId",
    "inputs": [{ "name": "", "type": "uint32", "internalType": "uint32" }],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getLzSendReceipt",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct MessagingReceipt",
        "components": [
          { "name": "guid", "type": "bytes32", "internalType": "bytes32" },
          { "name": "nonce", "type": "uint64", "internalType": "uint64" },
          {
            "name": "fee",
            "type": "tuple",
            "internalType": "struct MessagingFee",
            "components": [
              { "name": "nativeFee", "type": "uint256", "internalType": "uint256" },
              { "name": "lzTokenFee", "type": "uint256", "internalType": "uint256" }
            ]
          }
        ]
      },
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct OFTReceipt",
        "components": [
          { "name": "amountSentLD", "type": "uint256", "internalType": "uint256" },
          { "name": "amountReceivedLD", "type": "uint256", "internalType": "uint256" }
        ]
      },
      { "name": "", "type": "bytes", "internalType": "bytes" },
      { "name": "", "type": "bytes", "internalType": "bytes" }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getRoleAdmin",
    "inputs": [{ "name": "role", "type": "bytes32", "internalType": "bytes32" }],
    "outputs": [{ "name": "", "type": "bytes32", "internalType": "bytes32" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "grantRole",
    "inputs": [
      { "name": "role", "type": "bytes32", "internalType": "bytes32" },
      { "name": "account", "type": "address", "internalType": "address" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "hasRole",
    "inputs": [
      { "name": "role", "type": "bytes32", "internalType": "bytes32" },
      { "name": "account", "type": "address", "internalType": "address" }
    ],
    "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "initialize",
    "inputs": [
      { "name": "_oft", "type": "address", "internalType": "address" },
      { "name": "_usdc", "type": "address", "internalType": "address" },
      { "name": "_owner", "type": "address", "internalType": "address" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "ledgerAddr",
    "inputs": [],
    "outputs": [{ "name": "", "type": "address", "internalType": "address" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ledgerChainId",
    "inputs": [],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "lzCompose",
    "inputs": [
      { "name": "from", "type": "address", "internalType": "address" },
      { "name": "", "type": "bytes32", "internalType": "bytes32" },
      { "name": "_message", "type": "bytes", "internalType": "bytes" },
      { "name": "", "type": "address", "internalType": "address" },
      { "name": "", "type": "bytes", "internalType": "bytes" }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "lzEndpoint",
    "inputs": [],
    "outputs": [{ "name": "", "type": "address", "internalType": "address" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "myChainId",
    "inputs": [],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "orderTokenOft",
    "inputs": [],
    "outputs": [{ "name": "", "type": "address", "internalType": "address" }],
    "stateMutability": "view"
  },
  { "type": "function", "name": "pause", "inputs": [], "outputs": [], "stateMutability": "nonpayable" },
  {
    "type": "function",
    "name": "paused",
    "inputs": [],
    "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "payloadType2BackwardFee",
    "inputs": [{ "name": "", "type": "uint8", "internalType": "uint8" }],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "payloadType2DstGas",
    "inputs": [{ "name": "", "type": "uint8", "internalType": "uint8" }],
    "outputs": [{ "name": "", "type": "uint128", "internalType": "uint128" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "proxiableUUID",
    "inputs": [],
    "outputs": [{ "name": "", "type": "bytes32", "internalType": "bytes32" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteClaimReward",
    "inputs": [
      { "name": "distributionId", "type": "uint32", "internalType": "uint32" },
      { "name": "user", "type": "address", "internalType": "address" },
      { "name": "cumulativeAmount", "type": "uint256", "internalType": "uint256" },
      { "name": "merkleProof", "type": "bytes32[]", "internalType": "bytes32[]" }
    ],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteSendUserRequest",
    "inputs": [
      { "name": "amount", "type": "uint256", "internalType": "uint256" },
      { "name": "user", "type": "address", "internalType": "address" },
      { "name": "payloadType", "type": "uint8", "internalType": "uint8" }
    ],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteStakeOrder",
    "inputs": [
      { "name": "amount", "type": "uint256", "internalType": "uint256" },
      { "name": "sender", "type": "address", "internalType": "address" }
    ],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "renounceRole",
    "inputs": [
      { "name": "role", "type": "bytes32", "internalType": "bytes32" },
      { "name": "callerConfirmation", "type": "address", "internalType": "address" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "revokeRole",
    "inputs": [
      { "name": "role", "type": "bytes32", "internalType": "bytes32" },
      { "name": "account", "type": "address", "internalType": "address" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "sendUserRequest",
    "inputs": [
      { "name": "amount", "type": "uint256", "internalType": "uint256" },
      { "name": "payloadType", "type": "uint8", "internalType": "uint8" }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "setChainId2Eid",
    "inputs": [
      { "name": "chainId", "type": "uint256", "internalType": "uint256" },
      { "name": "eid", "type": "uint32", "internalType": "uint32" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setDefaultOftGas",
    "inputs": [{ "name": "_defaultOftGas", "type": "uint128", "internalType": "uint128" }],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setLedgerInfo",
    "inputs": [
      { "name": "_ledgerChainId", "type": "uint256", "internalType": "uint256" },
      { "name": "_ledgerAddr", "type": "address", "internalType": "address" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setLzEndpoint",
    "inputs": [{ "name": "_lzEndpoint", "type": "address", "internalType": "address" }],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setMyChainId",
    "inputs": [{ "name": "_myChainId", "type": "uint256", "internalType": "uint256" }],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOrderTokenOft",
    "inputs": [{ "name": "_orderTokenOft", "type": "address", "internalType": "address" }],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setPayloadType2BackwardFee",
    "inputs": [
      { "name": "payloadType", "type": "uint8", "internalType": "uint8" },
      { "name": "backwardFee", "type": "uint256", "internalType": "uint256" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setPayloadType2DstGas",
    "inputs": [
      { "name": "payloadType", "type": "uint8", "internalType": "uint8" },
      { "name": "dstGas", "type": "uint128", "internalType": "uint128" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "stakeOrder",
    "inputs": [{ "name": "amount", "type": "uint256", "internalType": "uint256" }],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "supportsInterface",
    "inputs": [{ "name": "interfaceId", "type": "bytes4", "internalType": "bytes4" }],
    "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
    "stateMutability": "view"
  },
  { "type": "function", "name": "unpause", "inputs": [], "outputs": [], "stateMutability": "nonpayable" },
  {
    "type": "function",
    "name": "upgradeToAndCall",
    "inputs": [
      { "name": "newImplementation", "type": "address", "internalType": "address" },
      { "name": "data", "type": "bytes", "internalType": "bytes" }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "usdcAddr",
    "inputs": [],
    "outputs": [{ "name": "", "type": "address", "internalType": "address" }],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "ClaimRewardTokenTransferred",
    "inputs": [
      { "name": "user", "type": "address", "indexed": true, "internalType": "address" },
      { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "ClaimUsdcRevenueTransferred",
    "inputs": [
      { "name": "user", "type": "address", "indexed": true, "internalType": "address" },
      { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "ClaimVestingRequestTransferred",
    "inputs": [
      { "name": "user", "type": "address", "indexed": true, "internalType": "address" },
      { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Initialized",
    "inputs": [{ "name": "version", "type": "uint64", "indexed": false, "internalType": "uint64" }],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Paused",
    "inputs": [{ "name": "account", "type": "address", "indexed": false, "internalType": "address" }],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "RoleAdminChanged",
    "inputs": [
      { "name": "role", "type": "bytes32", "indexed": true, "internalType": "bytes32" },
      { "name": "previousAdminRole", "type": "bytes32", "indexed": true, "internalType": "bytes32" },
      { "name": "newAdminRole", "type": "bytes32", "indexed": true, "internalType": "bytes32" }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "RoleGranted",
    "inputs": [
      { "name": "role", "type": "bytes32", "indexed": true, "internalType": "bytes32" },
      { "name": "account", "type": "address", "indexed": true, "internalType": "address" },
      { "name": "sender", "type": "address", "indexed": true, "internalType": "address" }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "RoleRevoked",
    "inputs": [
      { "name": "role", "type": "bytes32", "indexed": true, "internalType": "bytes32" },
      { "name": "account", "type": "address", "indexed": true, "internalType": "address" },
      { "name": "sender", "type": "address", "indexed": true, "internalType": "address" }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Unpaused",
    "inputs": [{ "name": "account", "type": "address", "indexed": false, "internalType": "address" }],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Upgraded",
    "inputs": [{ "name": "implementation", "type": "address", "indexed": true, "internalType": "address" }],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "WithdrawOrderTokenTransferred",
    "inputs": [
      { "name": "user", "type": "address", "indexed": true, "internalType": "address" },
      { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }
    ],
    "anonymous": false
  },
  { "type": "error", "name": "AccessControlBadConfirmation", "inputs": [] },
  {
    "type": "error",
    "name": "AccessControlUnauthorizedAccount",
    "inputs": [
      { "name": "account", "type": "address", "internalType": "address" },
      { "name": "neededRole", "type": "bytes32", "internalType": "bytes32" }
    ]
  },
  { "type": "error", "name": "AddressEmptyCode", "inputs": [{ "name": "target", "type": "address", "internalType": "address" }] },
  { "type": "error", "name": "AddressInsufficientBalance", "inputs": [{ "name": "account", "type": "address", "internalType": "address" }] },
  {
    "type": "error",
    "name": "ERC1967InvalidImplementation",
    "inputs": [{ "name": "implementation", "type": "address", "internalType": "address" }]
  },
  { "type": "error", "name": "ERC1967NonPayable", "inputs": [] },
  { "type": "error", "name": "EnforcedPause", "inputs": [] },
  { "type": "error", "name": "ExpectedPause", "inputs": [] },
  { "type": "error", "name": "FailedInnerCall", "inputs": [] },
  { "type": "error", "name": "InvalidInitialization", "inputs": [] },
  { "type": "error", "name": "InvalidOptionType", "inputs": [{ "name": "optionType", "type": "uint16", "internalType": "uint16" }] },
  { "type": "error", "name": "NotInitializing", "inputs": [] },
  { "type": "error", "name": "ReentrancyGuardReentrantCall", "inputs": [] },
  {
    "type": "error",
    "name": "SafeCastOverflowedUintDowncast",
    "inputs": [
      { "name": "bits", "type": "uint8", "internalType": "uint8" },
      { "name": "value", "type": "uint256", "internalType": "uint256" }
    ]
  },
  { "type": "error", "name": "SafeERC20FailedOperation", "inputs": [{ "name": "token", "type": "address", "internalType": "address" }] },
  { "type": "error", "name": "UUPSUnauthorizedCallContext", "inputs": [] },
  { "type": "error", "name": "UUPSUnsupportedProxiableUUID", "inputs": [{ "name": "slot", "type": "bytes32", "internalType": "bytes32" }] }
]